









import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Home extends Vue {
  // 10 游戏详情页--游戏详情--官方消息
  // 11 游戏详情页--游戏详情--官方宣传
  // 12 游戏详情页--评论--最新评价
  // 13 游戏详情页--评论--热门评论
  // 14 游戏详情页--评论--是否开启评论
  // 15 游戏详情页--同厂推荐
  // 16 游戏详情页--暂无任务
  // 17 游戏详情页--暂无今日开服
  // 18 游戏详情页--该游戏未配置礼包码奖励
  @Prop({ type: Number, default: "" }) public typeStatus;
  public list: any = [
    {
        id: 10,
        title: "暂无游戏",
        src: "/static/img/ques/ty2.png",
        className: "tyss"
    },
    {
        id: 11,
        title: "暂无游戏截图",
        src: "/static/img/ques/ty2.png",
        className: "tyss"
    },
    {
        id: 12,
        title: "暂无最新评论",
        src: "/static/img/ques/ty3.png",
        className: "ty"
    },
    {
        id: 13,
        title: "暂无热门评论",
        src: "/static/img/ques/ty3.png",
        className: "ty"
    },
    {
        id: 14,
        title: "此游戏暂未开启评价",
        src: "/static/img/ques/ty4.png",
        className: "ty"
    },
    {
        id: 15,
        title: "暂无游戏",
        src: "/static/img/ques/ty1.png",
        className: "ty"
    },
    {
        id: 16,
        title: "暂无任务",
        src: "/static/img/ques/ty1.png",
        className: "ty"
    },
    {
        id: 17,
        title: "暂无新服",
        src: "",
        className: "ty"
    },
    {
        id: 18,
        title: "该游戏未配置礼包码奖励",
        src: "",
        className: "ty"
    }
  ]
}
